// 连接地址
var ymtApi = "http://api.testkhd.yunmaotong.net/api/";
//var ymtApi = "http://khd-api.yunmaotong.net/api/";

var lochost=window.location.host
console.log(lochost)
if(lochost.indexOf('test')>-1 || lochost.indexOf("localhost")>-1){
  ymtApi = "http://api.testkhd.yunmaotong.net/api/";
}
else{
  ymtApi = "http://khd-api.yunmaotong.net/api/";
}

export default {
  ymtApi
};



// WEBPACK FOOTER //
// ./src/utils/global.js